import { CustomFieldDataType } from '@cims-online/shared'
import DescriptionFormItem from 'components/CIMSFormItem/common/DescriptionFormItem'
import NameFormItem from 'components/CIMSFormItem/common/NameFormItem'
import CIMSFormItem from 'components/CIMSFormItem'
import { HelpMessage } from 'utils/constants'
import { useState } from 'react'
import { Checkbox, Col, Row } from 'antd'
import CustomListItemFormItems from '../../../../components/CustomListItemFormItems'
import ReportIdsFormItem from '../../../../components/ReportIdsFormItem'
import EntityIdsFormItem from '../../../../components/EntityIdsFormItem'
import CustomFieldToClassTypeFormItems from '../../../../components/CustomFieldToClassTypeFormItems'
import StyleFormItem from './components/StyleFormItem'
import CIMSSelect from 'components/CIMSSelect'
import { useOptions } from 'components/CIMSSelect/hooks/useOptions'
const Help = HelpMessage.Administration.CustomFields

const CreateCustomFieldModalBody: React.FC = () => {
  const [dataTypeId, setDataTypeId] = useState<string | undefined>()
  const options = useOptions({
    items: CustomFieldDataType.values,
    label: 'name',
    tooltip: 'description',
    value: 'id',
    sort: 'name',
  })
  return (
    <>
      <Row gutter={[16, 0]} wrap={false}>
        <Col span={dataTypeId === CustomFieldDataType.Date.id ? 18 : 24}>
          <CIMSFormItem
            label="Data Type"
            name="dataTypeId"
            help={Help.DataType}
            requiredMessage="Please select a data type"
          >
            <CIMSSelect
              simple
              onChange={(value) => setDataTypeId(value as string)}
              options={options}
            />
          </CIMSFormItem>
        </Col>
        {dataTypeId === CustomFieldDataType.Date.id && (
          <Col span={6}>
            <CIMSFormItem
              name="timestamp"
              label="Timestamp"
              valuePropName="checked"
              help={Help.Timestamp}
            >
              <Checkbox />
            </CIMSFormItem>
          </Col>
        )}
      </Row>
      {dataTypeId === CustomFieldDataType.List.id && (
        <>
          <StyleFormItem />
          <CustomListItemFormItems />
        </>
      )}
      {dataTypeId === CustomFieldDataType.Entity.id && <EntityIdsFormItem />}
      {dataTypeId === CustomFieldDataType.Report.id && <ReportIdsFormItem />}
      <NameFormItem help={Help.Name} />
      <DescriptionFormItem entityName="Custom Field" />
      <CustomFieldToClassTypeFormItems />
    </>
  )
}

export default CreateCustomFieldModalBody
